
import React from "react";
import { useAuth } from "@/context/AuthContext";
import { SubscriptionActions } from "./SubscriptionActions";

interface AdminPanelProps {
  onProcessPayments: () => void;
  onExport: () => void;
  isProcessingPayments: boolean;
  isExporting: boolean;
}

export function AdminPanel({
  onProcessPayments,
  onExport,
  isProcessingPayments,
  isExporting
}: AdminPanelProps) {
  const { isAdmin } = useAuth();

  // Only render for admin users
  if (!isAdmin) {
    return null;
  }

  return (
    <SubscriptionActions
      onProcessPayments={onProcessPayments}
      onExport={onExport}
      isProcessingPayments={isProcessingPayments}
      isExporting={isExporting}
    />
  );
}
